import HeroApiService from './hero-api.service';

export const heroApiService = new HeroApiService();
